module.exports = __webpack_public_path__ + "media/3_32.377d3827.wav";